import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CrudGenericsService } from '../common/crud-generics';
import { Environment, MacchineCompTipo } from '../../models/-index';

@Injectable()
export class MacchineCompTipoService extends CrudGenericsService<MacchineCompTipo, number> {
  //  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/MacchineCompTipo`);
    //   this.base = `${env.apiUrl}/api/MacchineCompTipo/`;
  }
}
